export default __webpack_public_path__ + "static/media/defi-wallet-icon.e3257699.webp";